import React from 'react'

import CircularProgress from '@material-ui/core/CircularProgress'

function Loader(props) {
  const style = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 auto',
    width: '100%',
    ...props.style,
  }

  return (
    <div style={style}>
      <CircularProgress style={{ color: props.color ? props.color : '#00bcb5' }} />
    </div>
  )
}

export default Loader



// WEBPACK FOOTER //
// ./src/components/Loader.js